import Swiper from '../vendors/swiper.min.js';

export default class Sliders {
  static heroSlider() {
    return new Swiper('.hero__sliderwrap', {
      loop: true,
      loopedSlides: 5,
      speed: 1000,
      autoplay: { delay: 3000 },
      slidesPerView: 1
    });
  }

  static indexAppeal() {
    const el = document.querySelector('.appeal__wrap');
    if (!el) return;
    const wrapper = el.querySelector('.swiper-wrapper');
    const slides = el.querySelectorAll('.swiper-slide');
    let slider;
    let isInitialized = false;

    let options = {
      loop: true,
      loopedSlides: 5,
      speed: 1000,
      autoplay: {
        delay: 2500,
      },
      slidesPerView: 4,
      spaceBetween: 10,
      centeredSlides: true,
      breakpoints: {
        1250: {
          slidesPerView: 3
        },
        992: {
          slidesPerView: 2
        },
        768: {
          slidesPerView: 1
        }
      }
    };

    const init = () => {
      if (!isInitialized) {
        isInitialized = true;
        slider = new Swiper(el, options);
      }
    }

    window.addEventListener('resize', init);
    init();
  }

  static singleDiary() {
    let options = {
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 2000,
      },
      navigation: {
        nextEl: '.d-article__next',
        prevEl: '.d-article__prev',
      },
      pagination: {
        el: '.d-article__pagination',
      }
    };

    return new Swiper('.d-article__slider', options);
  }

  static singleVoice() {
    let options = {
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 2000,
      },
      navigation: {
        nextEl: '.v-article__next',
        prevEl: '.v-article__prev',
      },
      pagination: {
        el: '.v-article__pagination',
      }
    };

    return new Swiper('.v-article__slider', options);
  }

  static singleCourse() {
    let options = {
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 2000,
      },
      navigation: {
        nextEl: '.c-article__next',
        prevEl: '.c-article__prev',
      },
      pagination: {
        el: '.c-article__pagination',
      }
    };

    return new Swiper('.c-article__slider', options);
  }
}
